import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBody, ModalHeader } from 'reactstrap';
import { IModalProps } from '../../../types';
import { FilterFeaturesTableForm } from '../../Features/FilterFeaturesTableForm';

export const FilterFeatures: FunctionComponent<IModalProps> = (props) => {
  const { hideModal } = props;

  const { t } = useTranslation();

  return (
    <>
      <ModalHeader className="font-montserrat m-0 border-0">
        {t('features.modals.filter.header')}
      </ModalHeader>
      <ModalBody>
        <FilterFeaturesTableForm onCancel={hideModal} />
      </ModalBody>
    </>
  );
};
